import { Outlet } from "react-router-dom";
import { ChatUnreadHeaderProvider } from "../chat/ChatUnreadHeaderProvider";
import { NotificationHeaderProvider } from "../notifications/NotificationHeaderProvider";

/**
 * Renders global route-level UI and the active route via Outlet.
 * Session extension uses refresh tokens (see axios 401 handler), not SessionExpiryManager.
 */
export default function AppRouteShell() {
  return (
    <NotificationHeaderProvider>
      <ChatUnreadHeaderProvider>
        <Outlet />
      </ChatUnreadHeaderProvider>
    </NotificationHeaderProvider>
  );
}
